import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { HttpClientHelper } from 'app/_service/http-helper';
import { UserService } from 'app/_service/user/user.service';
import { Subscription } from 'rxjs';
import { NewsService } from '../../_service/news/news.service';
import { WindowService } from '../../_service/screen-size.service';
//import { WindowService, ScreenSize } from '../../_service/screen-size.service';

@Component({
  selector: 'app-recommended-news',
  templateUrl: './recommended-news.component.html',
  styleUrls: ['../../index/index.share.scss', './recommended-news.component.scss'],
  // providers: [NewsService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RecommendedNewsComponent implements OnInit, OnDestroy {
  // screenType = ScreenSize;
  // screenSize;
  sliderItems = [];

  //public recommendedNewsCategories;
  public recommendedNewsList = [];
  
  newsList = [];
  // newSvideoSize = {
  //   width: 437,
  //   height: 437 / 16 *9,
  // };
  newColumn = 4;
  @ViewChild('track') track: ElementRef;
  currentIndex = 0;
  //screenSize: ScreenSize = ScreenSize.ExtraLarge;
  showOutDated = false;

  @Input() title = '今日热点';
  @Input() isNews = true; // 只取新闻小视频
  user;
  lastuid = 0;
  subscriptions: Subscription[] = [];
  playingMediaKey = '';
  constructor(
    private _news: NewsService,
    private _cd:ChangeDetectorRef,
    private _windowService: WindowService,
    private _userService: UserService,
    private httpHelper: HttpClientHelper,
  ) { }

  private detectChange(value)
  {
    var previous = this.newColumn;
    let current = value == 5?4:3;
    this.newColumn = current;
    if(previous != current)
    {
      this.moveTrack();
      this._cd.detectChanges();
    }
  
  }
  ngOnInit() {
    this.user = this._userService.user;
    this.lastuid = this.httpHelper.token.uid || 0;
    this.subscriptions.push(
      this._userService.userState$.subscribe(p => {
        this.user = p;
        this.readState();
      }),
      this._windowService.size$.subscribe((value: any) => {
       this.detectChange(value);
      })
    );

    // this._news.getRecommendedNewsCategories()
    //   .subscribe(result => {
    //     this.recommendedNewsCategories = result;
    //   });
    this._news.getRecommendedNewsList(this.isNews)
      .subscribe(result => {
        if (null != result && result.length > 0) {
          // this.sliderItems = result.slice(0, 5);
          // this.recommendedNewsList = result.slice(5);
          // this.setPart();
          this.newsList = result;
          this._cd.detectChanges();
        }
      });
  }

  readState() {
    if (this.user.id > 0 && this.lastuid != this.user.id) {
      if (!this.isNews) {
        this.onUserChanged();
      }
    }
    this.lastuid = !!this.user.id ? this.user.id : this.lastuid;
  }

  onUserChanged() {
    this._news.getRecommendedNewsList(this.isNews, true)
    .subscribe(result => {
      if (null != result && result.length > 0) {
        this.newsList = result;
        this._cd.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  setPart()
  {
    this.firstPart = this.recommendedNewsList.slice(0,6);
    this.secondPart = this.recommendedNewsList.slice(6,6 * 2);
    this._cd.detectChanges();
  }
  firstPart = [];
  secondPart = [];

  responsiveGutterWidth(isLast) {
    if (isLast) {
      return 0;
    }

    // if (this.screenSize === this.screenType.XSmall) {
    //   return 10;
    // }
    // if (this.screenSize === this.screenType.Small) {
    //   return 15;
    // }

    // if (this.screenSize === this.screenType.Medium) {
    //   return 15;
    // }

    // if (this.screenSize === this.screenType.Large) {
    //   return 20;
    // }

    return 5;
  }
  // responsiveRowItems = 6;
  // tryresponsiveRowItems() {
  //   if (this.screenSize === this.screenType.XSmall) {
  //     return 4;
  //   }
  //   if (this.screenSize === this.screenType.Small) {
  //     return 4;
  //   }
  //   if (this.screenSize === this.screenType.Medium) {
  //     return 4;
  //   }
  //   if (this.screenSize === this.screenType.Large) {
  //     return 5;
  //   }
  //   return 6;
  // }
  // responsiveTeaserSize = { width: 206, height: 115 }

  // trySetTeaseSize() {
  //   if (this.screenSize === this.screenType.Large) {
  //     return { width: 213, height: 119 };
  //   }

  //   if (this.screenSize == this.screenType.ExtraLarge) {
  //     return { width: 216, height: 120 };
  //   }
  //   return { width: 206, height: 115 };
  //   // if (this.screenSize === this.screenType.XSmall) {
  //   //   return { width: 206, height: 115 };
  //   // }
  //   // if (this.screenSize === this.screenType.Small) {
  //   //   return { width: 206, height: 115 };
  //   // }
  //   // if (this.screenSize === this.screenType.Medium) {
  //   //   return { width: 206, height: 115 };
  //   // }
  //   // if (this.screenSize === this.screenType.Large) {
  //   //   return { width: 210, height: 118 };
  //   // }
  //   // return { width: 218, height: 122 };
  // }
  //responsiveTeaserSize = {width: 238, height: 126}
  // responsiveTeaserSize() {
  //   // if (this.screenSize === this.screenType.XSmall) {
  //   //   return { width: 190, height: 101 };
  //   // }
  //   // if (this.screenSize === this.screenType.Small) {
  //   //   return { width: 195, height: 101 };
  //   // }
  //   // if (this.screenSize === this.screenType.Medium) {
  //   //   return { width: 210, height: 118 };
  //   // }
  //   // if (this.screenSize === this.screenType.Large) {
  //   //   return { width: 210, height: 123 };
  //   // }
  //   return {width: 238, height: 126};
  // }

  getSliderTrackItemSize() {
    
    // if (this.screenSize === ScreenSize.XSmall) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    // } else if (this.screenSize === ScreenSize.Small) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    // } else if (this.screenSize === ScreenSize.Medium) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    // } else if (this.screenSize === ScreenSize.Large) {
    //   this.newSvideoSize = {
    //     width: 438,
    //     height: 438 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    // } else if (this.screenSize === ScreenSize.ExtraLarge) {
    //   this.newSvideoSize = {
    //     width: 437,
    //     height: 437 / 16 * 9,
    //   };
    //   this.newColumn = 4;
    // } else {
    //   this.newSvideoSize = {
    //     width: 437,
    //     height: 437 / 16 * 9,
    //   };
    //   this.newColumn = 4;
    // }
    // this.moveTrack();
    // this._cd.detectChanges();
  }

  navLast() {
    this.currentIndex -= this.newColumn; // 一次滑动的数量根据尺寸来定
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  navNext() {
    this.currentIndex += this.newColumn; // 一次滑动的数量根据尺寸来定
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  moveTrack(useAnimation = false) {
    const trackElement = this.track?.nativeElement as HTMLElement;
    // console.log(trackElement);
    if (!!trackElement) {
      let box = trackElement.getElementsByClassName("new-svideo-container").item(0);
      if(box== null)
      {
        return;
      }
      if (useAnimation) {
        trackElement.classList.add('animation');
      } else {
        trackElement.classList.remove('animation');
      }
      const properIndex = (this.newsList.length - this.newColumn);
      if (this.currentIndex >= properIndex) {
        this.currentIndex = properIndex > 0 ? properIndex : 0;
      }
      trackElement.style.transform = `translate3d(${ (box.clientWidth + 5) * -(this.currentIndex) }px, 0px, 0px)`;
    }
  }

  currentMediaKeyHandler(e) {
    this.playingMediaKey = e;
  }

  previewHandler(playerShowed) {
    if (playerShowed === true) {
      let firstItem;
      let lastItem;
      if (this.currentIndex < this.newColumn) {
        const lastItemIndex = this.currentIndex + (this.newColumn - 1);
        lastItem = this.newsList[lastItemIndex];
      } else {
        const firstItemIndex = this.currentIndex;
        firstItem = this.newsList[firstItemIndex];
        const lastItemIndex = this.currentIndex + (this.newColumn - 1);
        lastItem = this.newsList[lastItemIndex];
      }
      this.zIndexChange(firstItem, lastItem);
    } else {
      this.hideLeft = false;
      this.hideRight = false;
    }
  }

  hideLeft = false;
  hideRight = false;

  zIndexChange(firstItem = undefined, lastItem = undefined) {
    if (!!firstItem && firstItem.key === this.playingMediaKey) {
      this.hideLeft = true;
    }
    if (!!lastItem && lastItem.key === this.playingMediaKey) {
      this.hideRight = true;
    }
  }
}
